module.exports = __webpack_public_path__ + "462b9f11e90a1be66e573c60ac607711.svg";